import React, { useState, useEffect } from "react";
import axios from 'axios';
import {instance, instance2} from '../../utils/axiosInstance'


export default function Editmodal({ user, onClose, onSaved }) {
  const [formData, setFormData] = useState({
    nama: "",
    username: "",
    noHp: "",
    role: "",
    secondaryOption: "",
    password: "",
    confirmPassword: "",
    sppg_name: "",
    pos: "",
  });

  useEffect(() => {
    if (user) {
      setFormData({
        nama: user.namalengkap || "",
        username: user.nama || "",
        noHp: user.noHp || "",
        role: user.role_id?.toString() || "", // Ensure role_id is treated as a string
        secondaryOption:
          user.role_id === 2
            ? user.lokasi_id || ""
            : user.role_id === 3 || user.role_id === 5
            ? user.dapur_id || ""
            : "", // Set secondaryOption based on role
        password: "",
        confirmPassword: "",
        sppg_name: user.sppg_name || "",
        pos: user.jabatan || "",
      });      
    }
  }, [user]);


  const [roles, setRoles] = useState([]); // State to store roles fetched from backend
  const [position, setPosition] = useState([]); // State to store roles fetched from backend
  const [loading, setLoading] = useState(true); // Loading state
  const [error, setError] = useState(null); // Error state
  const [passwordsMatch, setPasswordsMatch] = useState(true); // Password match validation
  const [secondaryOptions, setSecondaryOptions] = useState([]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (formData.role === '2') {
          // Fetch data from API 1 using instance2
          const response = await instance2.get('location'); // Replace with your actual endpoint
          setSecondaryOptions(response.data);
        } else if (formData.role === '3' || formData.role === '5' ) {
          // Fetch data from API 2 using instance2
          const response = await instance2.get('kitchen'); // Replace with your actual endpoint
          setSecondaryOptions(response.data);
        } else {
          setSecondaryOptions([]);
        }
      } catch (error) {
        console.error('Error fetching secondary options:', error);
      }
    };

    fetchData();
  }, [formData.role]);

  useEffect(() => {
    const fetchRoles = async () => {
      try {
        const response = await instance2.get("roles"); // Use instance2 for the API call
  
        const rolesData = response.data; // Access data directly from Axios response
  
        setRoles(rolesData.map((role) => ({ id: role.id, name: role.name })));
      } catch (err) {
        console.error("Failed to fetch roles", err);
        setError(err.response?.data?.message || "Failed to fetch roles");
      } finally {
        setLoading(false);
      }
    };
  
    fetchRoles();
  }, []);
  
  //   useEffect(() => {
  //   const fetchPosition = async () => {
  //     try {
  //       const response = await instance2.get("admin_pos"); // Use instance2 for the API call
  
  //       const positonData = response.data; // Access data directly from Axios response
  
  //       setPosition(positonData.map((pos) => ({ id: pos.id, name: pos.name })));
  //     } catch (err) {
  //       console.error("Failed to fetch pos", err);
  //       setError(err.response?.data?.message || "Failed to fetch roles");
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  
  //   fetchPosition();
  // }, []);

  // Validate passwords match
  useEffect(() => {
    setPasswordsMatch(formData.password === formData.confirmPassword);
  }, [formData.password, formData.confirmPassword]);

  const isFormValid = () => {
    const { nama, username, noHp, role, secondaryOption } = formData;
  
    // Validate all required fields and conditionally validate secondaryOption based on role
    return (
      nama &&
      username &&
      noHp &&
      role &&
      role &&
      (role === "2" || role === "3" ? secondaryOption : true) // Ensure secondaryOption is filled for roles 2 or 3
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent default form submission
  
    try {
      // Build the request body dynamically
      const requestBody = {
        ...(formData.role === "2"
          ? { location_name: formData.secondaryOption }
          : formData.role === "3" || formData.role === '5' 
          ? { kitchen_name: formData.secondaryOption }
          : {}),
        name: formData.nama,
        username: formData.username,
        phone: formData.noHp,
        password: formData.password,
        role: formData.role,
        sppg_name: formData.sppg_name,
        pos: formData.pos,
      };
      
      console.log("Request Body:", requestBody); // Log the request body for debugging

      // Make the API call using instance2
      const response = await instance2.put(
        `admins/${user.id}`,
        requestBody
      );
  
      // Handle the successful response
      console.log("Admin saved successfully:", response.data);
  
      // Reload the page and close the modal
      //window.location.reload();
      onSaved?.();   // parent refreshes its list
      onClose();
    } catch (error) {
      // Handle errors
      console.error("Error saving admin:", error);
      alert("An error occurred while saving the admin. Please try again.");
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg w-[400px]">
        <h2 className="text-xl font-bold mb-4">Ubah Admin</h2>
        {loading ? (
          <p>Loading roles...</p>
        ) : error ? (
          <p className="text-red-500">{error}</p>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label className="block text-gray-700 mb-2">Nama</label>
              <input
                type="text"
                name="nama"
                value={formData.nama}
                onChange={(e) => {
                  // const uppercasedValue = e.target.value.toUpperCase();
                  handleChange({ target: { name: e.target.name, value: e.target.value } });
                }}
                className="w-full px-3 py-2 border rounded"
                placeholder="Nama Admin"
                required
              />
            </div>
            <div className="mb-4">
              <label className="block text-gray-700 mb-2">Username</label>
              <input
                type="text"
                name="username"
                value={formData.username}
                onChange={(e) => {
                  const lowercasedValue = e.target.value.toLowerCase();
                  handleChange({ target: { name: e.target.name, value: lowercasedValue } });
                }}
                className="w-full px-3 py-2 border rounded"
                placeholder="Username"
                required
              />
            </div>
            <div className="mb-4">
  <label className="block text-gray-700 mb-2">No HP</label>
  <input
    type="tel"
    name="noHp"
    value={formData.noHp}
    onChange={(e) => {
      const numericValue = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
      handleChange({ target: { name: e.target.name, value: numericValue } });
    }}
    className="w-full px-3 py-2 border rounded"
    placeholder="No HP"
    required
  />
</div>

            <div className="mb-4">
              <label className="block text-gray-700 mb-2">Peran</label>
              <select
                name="role"
                value={formData.role}
                onChange={handleChange}
                className="w-full px-3 py-2 border rounded"
                required
              >
                <option value="" disabled>
                  Pilih Peran
                </option>
                {roles.map((role) => (
                  <option key={role.id} value={role.id}>
                    {role.name}
                  </option>
                ))}
              </select>
            </div>
                  {/* <div className="mb-4">
  <label className="block text-gray-700 mb-2">Nama SPPG</label>
  <input
    type="text"
    name="sppg_name"
    value={formData.sppg_name}
    onChange={(e) => {
      handleChange({ target: { name: e.target.name, value: e.target.value } });
    }}
    className="w-full px-3 py-2 border rounded"
    placeholder="Nama SPPG"
    required
  />
</div> */}

                  {/* <div className="mb-4">
              <label className="block text-gray-700 mb-2">Jabatan</label>
              <select
                name="pos"
                value={formData.pos}
                onChange={handleChange}
                className="w-full px-3 py-2 border rounded"
                required
              >
                <option value="" disabled>
                  Pilih Peran
                </option>
                {position.map((pos) => (
                  <option key={pos.id} value={pos.id}>
                    {pos.name}
                  </option>
                ))}
              </select>
            </div> */}
            {(formData.role === "2" || formData.role === "3"|| formData.role === "5") && (
              
  <div className="mb-4">
    <label className="block text-gray-700 mb-2">{formData.role === "2"? "Koperasi" : "Dapur"}</label>
    <select
      name="secondaryOption"
      value={formData.secondaryOption}
      onChange={handleChange}
      className="w-full px-3 py-2 border rounded"
      required
    >
      <option value="" disabled>
        Pilih Opsi
      </option>
      {secondaryOptions.map((option) => (
        <option key={option.id} value={option.id}>
          {formData.role === "2"
            ? option.location_name
            : formData.role === "3" ||  formData.role === "5"
            ? option.kitchen_name
            : ""}
        </option>
      ))}
    </select>
  </div>
)}
           <div className="mb-4">
  <label className="block text-gray-700 mb-2">Reset Kata Sandi</label>
  <div className="flex items-center gap-2">
    <input
      type="checkbox"
      id="resetPassword"
      onChange={(e) =>
        setFormData((prev) => ({
          ...prev,
          password: e.target.checked ? "DefaultPassword123" : null,
        }))
      }
    />
    <label htmlFor="resetPassword" className="text-gray-700">
      Reset Password ke Default
    </label>
  </div>
</div>
{formData.password && (
  <div className="mb-4">
    <label className="block text-gray-700 mb-2">Password Baru</label>
    <input
      type="text"
      name="password"
      value={formData.password}
      disabled
      className="w-full px-3 py-2 border rounded bg-gray-200 text-gray-700 cursor-not-allowed"
      placeholder="Kata Sandi"
    />
  </div>
)}

            <div className="flex justify-end gap-4">
              <button
                type="button"
                className="px-4 py-2 bg-gray-300 rounded"
                onClick={onClose}
              >
                Batal
              </button>
              <button
                type="submit"
                className={`px-4 py-2 rounded text-white ${
                  isFormValid()
                    ? "bg-blue-500 hover:bg-blue-600"
                    : "bg-gray-300 cursor-not-allowed"
                }`}
                disabled={!isFormValid()}
              >
                Simpan
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
